import React from 'react'
import AddTherapistV2 from './AddTherapistV2'

function index() {
  return (
    <AddTherapistV2 />
  )
}

export default index


// below is the old code 

// import React, { useEffect, useMemo, useState } from "react";
// import { Button, Col, Container, Form, Row } from "react-bootstrap";
// import Switch from "react-switch";
// import "react-phone-input-2/lib/style.css";
// // css
// import styles from "./addForm.module.scss";
// import { Formik } from "formik";
// import addTherapistFormSchema from "./AddTherapistForm.schema";
// import LoadingButton from "components/shared/LoadingButton";
// import {
//   useCreateTherapistMutation,
//   useGetTherapistDataQuery,
//   useUpdateTherapistMutation,
// } from "store/services/therapistProfiles";
// import { useNavigate, useParams, Link } from "react-router-dom";
// import AppInputField from "components/shared/FormComponents/AppInputField";
// import AppSelectField from "components/shared/FormComponents/AppSelectField";
// import AppFileUploadField from "components/shared/FormComponents/AppFileUploadField";
// import { CLIENT_TYPE_OPTIONS, MIME_TYPES, TIMEZONE_OPTIONS } from "config/constants";
// import { useDisciplineLookupQuery } from "store/services/disciplines";
// import { cloneDeep, isEmpty } from "lodash";
// import AppProfilePictureField from "components/shared/FormComponents/AppProfilePictureField";
// import { successMessageToast } from "helpers/common";
// import { THERAPIST_LIST } from "config/paths";
// import ErrorComponent from "components/shared/ErrorComponent";
// import LoadingIndicator from "components/shared/LoadingIndicator";
// import { useDesignationLookupQuery } from "store/services/designations";
// import { CommonMultiSelect, CommonSelect, RequiredFieldAstrick } from "components/Common/Common";
// import { genericFormErrorMsg } from "utils/validation/validationHelpers";
// import AlertPop from "components/Modals/AlertPop";
// import ViewAttachments from "pages/SideTabPages/ManageSupportStaff/TaskSessionView/ViewAttachments";
// import { useLazyGetFileUrlQuery } from "store/services/utility";
// import LoadingOverlay from "components/shared/LoadingOverlay";

// const AddTherapist = () => {
//   const { id: therapistId } = useParams();
//   const editMode = !!therapistId;
//   const navigate = useNavigate();

//   const {
//     data: therapistData,
//     isLoading: getTherapistLoading,
//     isError: getTherapistError,
//   } = useGetTherapistDataQuery(therapistId, { skip: !therapistId });

//   const [createTherapist, { isLoading }] = useCreateTherapistMutation();
//   const [updateTherapist, { isLoading: updateTherapistLoading }] = useUpdateTherapistMutation();
//   const [getFileUrl, { isLoading: getFileLoading, isFetching: getFileFetching }] = useLazyGetFileUrlQuery();

//   const { data: disciplinesList } = useDisciplineLookupQuery({});

//   const { data: designationsList } = useDesignationLookupQuery();

//   const [isTherapistActive, setTherapistActive] = useState(false);
//   const [allowDocUpload, setAllowDocUpload] = useState(true);

//   const [showAlertPop, setShowAlertPop] = useState(false);
//   const [alertMessage, setAlertMessage] = useState(null);

//   const initialValues = useMemo(() => {
//     if (editMode && !therapistData) {
//       return defaultInitialValues;
//     }

//     return ({
//       ...defaultInitialValues,
//       firstname: therapistData?.firstname,
//       lastname: therapistData?.lastname,
//       phone: therapistData?.phone,
//       email: therapistData?.email,
//       discipline_id: therapistData?.therapist_detail?.discipline_id ? {
//         value: therapistData?.therapist_detail?.discipline_id,
//         label: therapistData?.therapist_detail?.therapist_discipline?.name
//       } : "",
//       type: therapistData?.type || "veteran",
//       designation_id: therapistData?.therapist_detail?.designation_id ? {
//         value: therapistData?.therapist_detail?.designation_id,
//         label: therapistData?.therapist_detail?.therapist_designation?.title
//       } : "",
//       registration_number: therapistData?.therapist_detail?.registration_number || "",
//       insurance_policy_number: therapistData?.therapist_detail?.insurance_policy_number || "",
//       assigned_client_category: therapistData?.therapist_detail?.assigned_client_category?.split(",")?.filter(Boolean).map(item => CLIENT_TYPE_OPTIONS?.find(x => x.value == item)),
//       calendly_link: therapistData?.therapist_detail?.calendly_link || "",
//       self_description: therapistData?.therapist_detail?.self_description || "",
//       profile_picture: therapistData?.therapist_detail?.profile_picture || "",
//       email_signature: therapistData?.therapist_detail?.email_signature || "",
//       signature_img: therapistData?.therapist_detail?.signature_img || "",
//       status: isTherapistActive ? "active" : "archived",
//       document_upload: allowDocUpload ? "allow" : "deny",
//       documents: therapistData?.clientResources?.map(({ attachment_key, attachment_name, id }) => ({ attachment_key, attachment_name, id })) || [],
//       timezone: { label: therapistData?.therapist_detail?.timezone, value: therapistData?.therapist_detail?.timezone }
//     })
//   }, [therapistData, isTherapistActive, allowDocUpload])

//   useEffect(() => {
//     if (!therapistData) {
//       return;
//     }
//     setAllowDocUpload(therapistData?.document_upload === "allow");
//     setTherapistActive(therapistData?.status === "active");
//   }, [therapistData]);

//   const handleTherapistStatus = (checked) => {
//     setTherapistActive(checked);
//   };

//   const handleToggleDocUpload = (checked) => {
//     setAllowDocUpload(checked);
//   };

//   const handleClickCancel = () => {
//     navigate(THERAPIST_LIST);
//   };

//   const handleSubmit = async (payload) => {
//     try {
//       let result;
//       let values = cloneDeep(payload);
//       values.email = values.email?.toLowerCase();
//       values.designation_id = values.designation_id?.value;
//       values.discipline_id = values.discipline_id?.value;
//       values.insurance_policy_number = values.insurance_policy_number || "";
//       values.registration_number = values.registration_number || "";
//       values.assigned_client_category = values?.assigned_client_category?.reduce((acc, item) => acc += `${item?.value},`, "")
//       values.timezone = values.timezone.value

//       if (editMode) {
//         result = await updateTherapist({
//           id: therapistId,
//           payload: values,
//         });
//       } else {
//         result = await createTherapist(values);
//       }

//       if (result.error) {
//         console.error("Error creating Designation", result.error);
//       } else {
//         successMessageToast(result?.data?.message);
//         navigate(THERAPIST_LIST);
//       }
//     } catch (err) {
//       console.log("Error creating Designation", err);
//     }
//   };

//   const handleAttachDocument = (name, value, prevValues, setFieldValue) => {
//     try {
//       let cloneValues = cloneDeep(prevValues);
//       cloneValues.push({
//         attachment_key: value,
//         attachment_name: value,
//       })
//       setFieldValue(name, cloneValues);
//     } catch (err) {
//       console.error("Failed to attach document", err);
//     }
//   };

//   const handleViewPdf = async (name) => {
//     try {
//       const url = await getFileUrl(name).unwrap();
//       if (url) window.open(url, '_blank');

//     } catch (err) { console.error("Error assigning therapist", err); }
//   };

//   return (
//     <>
//       <AlertPop
//         confirmation={showAlertPop}
//         setConfirmation={setShowAlertPop}
//         message={alertMessage}
//       />
//       {
//         getFileFetching && <LoadingOverlay/>
//       }
//       <section className={`${styles.addForm} position-relative py-4 addForm`}>
//         <Container fluid={true}>
//           <Row>
//             <Col lg="12" className="my-2">
//               <div className="pageHead d-flex align-items-center justify-content-between flex-wrap">
//                 <div className="d-flex align-items-center">
//                   <Link
//                     className="themeBlue fw-sbold back-to-btn"
//                     to="/manage-team/therapist-profiles/"
//                   >
//                     <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
//                       <path d="M6 12L0 6L6 0L7.425 1.4L2.825 6L7.425 10.6L6 12ZM18 14V10C18 9.16667 17.7083 8.45833 17.125 7.875C16.5417 7.29167 15.8333 7 15 7H8.825L12.425 10.6L11 12L5 6L11 0L12.425 1.4L8.825 5H15C16.3833 5 17.5625 5.4875 18.5375 6.4625C19.5125 7.4375 20 8.61667 20 10V14H18Z" fill="#1C1B1F" />
//                     </svg> Back
//                   </Link>
//                   <h6 className="m-0 fw-bold themeBlue">{editMode ? "Edit Therapist" : "Add New Therapist"}</h6>
//                 </div>
//                 <div className="right">
//                   <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10">
//                     <li className="d-flex align-items-center gap-10 px-2">
//                       <label
//                         htmlFor=""
//                         className="form-label themeBlue fw-bold mb-0"
//                       >
//                         Upload Document
//                       </label>
//                       <div className=" d-flex align-items-center">
//                         <p className="m-0 text-muted mx-1">Off</p>
//                         <Switch
//                           uncheckedIcon={""}
//                           checkedIcon={""}
//                           onHandleColor={"#A3DF00"}
//                           offHandleColor={"#A3DF00"}
//                           onColor={"#E6E6E6"}
//                           offColor={"#E6E6E6"}
//                           height={18}
//                           width={40}
//                           onChange={handleToggleDocUpload}
//                           checked={allowDocUpload}
//                         />
//                         <p className="m-0 text-muted mx-1">On</p>
//                       </div>
//                     </li>
//                     <li className="d-flex align-items-center gap-10 px-2">
//                       <label
//                         htmlFor=""
//                         className="form-label themeBlue fw-bold mb-0"
//                       >
//                         Activate Status
//                       </label>
//                       <div className=" d-flex align-items-center">
//                         <p className="m-0 text-muted mx-1">Inactive</p>
//                         <Switch
//                           uncheckedIcon={""}
//                           checkedIcon={""}
//                           onHandleColor={"#A3DF00"}
//                           offHandleColor={"#A3DF00"}
//                           onColor={"#E6E6E6"}
//                           offColor={"#E6E6E6"}
//                           height={18}
//                           width={40}
//                           onChange={handleTherapistStatus}
//                           checked={isTherapistActive}
//                         />
//                         <p className="m-0 text-muted mx-1">Active</p>
//                       </div>
//                     </li>
//                   </ul>
//                 </div>
//               </div>
//             </Col>
//             <Col lg="12" className="my-2">
//               {getTherapistLoading ? (
//                 <LoadingIndicator />
//               ) : getTherapistError ? (
//                 <ErrorComponent />
//               ) : (
//                 <Formik
//                   initialValues={initialValues}
//                   validationSchema={addTherapistFormSchema}
//                   onSubmit={handleSubmit}
//                   enableReinitialize
//                 >
//                   {({
//                     handleSubmit,
//                     isSubmitting,
//                     errors,
//                     submitCount,
//                     values,
//                     setFieldValue,
//                     validateForm
//                   }) => (
//                     <Form onSubmit={handleSubmit}>
//                       <div
//                         className="py-3"
//                         style={{ borderTop: "1px solid #41a2a84d" }}
//                       >
//                         <Row>
//                           <Col lg="3" md="4" sm="6" className="my-2">
//                             <label
//                               htmlFor=""
//                               className="form-label themeBlue fw-bold mb-0 d-flex"
//                             >
//                               Profile Picture
//                             </label>
//                             <AppProfilePictureField
//                               name="profile_picture"
//                               acl={"public-read"}
//                               accept="image/*"
//                               allowedTypes={[MIME_TYPES.jpeg, MIME_TYPES.jpg, MIME_TYPES.png]}
//                             />
//                           </Col>
//                           <Col lg="3" md="4" sm="6" className="my-2">
//                             <label
//                               htmlFor=""
//                               className="form-label themeBlue fw-bold mb-0 d-flex"
//                             >
//                               Last Name
//                               <RequiredFieldAstrick />
//                             </label>
//                             <AppInputField
//                               name="lastname"
//                               placeholder="e.g Smith"
//                               className={`${styles.formControl} form-control`}
//                             />
//                           </Col>
//                           <Col lg="3" md="4" sm="6" className="my-2">
//                             <label
//                               htmlFor=""
//                               className="form-label themeBlue fw-bold mb-0 d-flex"
//                             >
//                               First Name
//                               <RequiredFieldAstrick />
//                             </label>
//                             <AppInputField
//                               name="firstname"
//                               placeholder="e.g John"
//                               className={`${styles.formControl} form-control`}
//                             />
//                           </Col>
//                           <Col lg="3" md="4" sm="6" className="my-2">
//                             <label
//                               htmlFor=""
//                               className="form-label themeBlue fw-bold mb-0 d-flex"
//                             >
//                               Email
//                               <RequiredFieldAstrick />
//                             </label>
//                             <AppInputField
//                               type="email"
//                               name="email"
//                               placeholder="e.g Johndemo@domain.com"
//                               className={`${styles.formControl} form-control`}
//                             />
//                           </Col>
//                           <Col lg="3" md="4" sm="6" className="my-2">
//                             <label
//                               htmlFor=""
//                               className="form-label themeBlue fw-bold mb-0 d-flex"
//                             >
//                               Phone Number
//                               <RequiredFieldAstrick />
//                             </label>
//                             <AppInputField
//                               name="phone"
//                               placeholder="e.g +1 234567890"
//                               className={`${styles.formControl} form-control`}
//                               maxLength={25}
//                             />
//                           </Col>
//                           <Col lg="3" md="4" sm="6" className="my-2">
//                             <label
//                               htmlFor=""
//                               className="form-label themeBlue fw-bold mb-0 d-flex"
//                             >
//                               Discipline
//                               <RequiredFieldAstrick />
//                             </label>
//                             <CommonSelect
//                               name="discipline_id"
//                               placeholder="Select Discipline"
//                               option={
//                                 disciplinesList?.length && disciplinesList?.map((item) => ({
//                                   value: item.id,
//                                   label: item.name,
//                                 }))
//                               }
//                               onChange={(item) => {
//                                 if (editMode && item.value !== therapistData?.discipline_id) {
//                                   setAlertMessage("Changing the discipline for an existing therapist may cause the loss in the saved report progress");
//                                   setShowAlertPop(true);
//                                 }
//                               }}
//                             />
//                           </Col>
//                           <Col lg="3" md="4" sm="6" className="my-2">
//                             <label
//                               htmlFor=""
//                               className="form-label themeBlue fw-bold mb-0 d-flex"
//                             >
//                               Designation
//                               <RequiredFieldAstrick />
//                             </label>
//                             <CommonSelect
//                               name="designation_id"
//                               option={
//                                 designationsList?.length && designationsList?.map((item) => ({
//                                   value: item.id,
//                                   label: item.title,
//                                 }))
//                               }
//                             // onChange={(item) => {
//                             //   setFieldValue("designation_id", item?.value || null);
//                             // }}
//                             />
//                           </Col>
//                           <Col lg="3" md="4" sm="6" className="my-2">
//                             <label
//                               htmlFor=""
//                               className="form-label themeBlue fw-bold mb-0 d-flex"
//                             >
//                               Therapist Type
//                               <RequiredFieldAstrick />
//                             </label>
//                             <AppSelectField
//                               name="type"
//                               options={[
//                                 { value: "veteran", label: "Veteran" },
//                                 { value: "apprentice", label: "Apprentice" },
//                               ]}
//                               className={`${styles.formControl} form-control`}
//                               onChange={(e) => {
//                                 setFieldValue("type", e.target.value)
//                                 if (editMode && e.target.value !== therapistData?.type) {
//                                   setAlertMessage("Changing the type for an existing therapist may cause the report data loss");
//                                   setShowAlertPop(true);
//                                 }
//                               }}
//                             />
//                           </Col>
//                           {/* <Col lg="3" md="4" sm="6" className="my-2">
//                             <label
//                               htmlFor=""
//                               className="form-label themeBlue fw-bold mb-0"
//                             >
//                               Therapist Designation
//                             </label>
//                             <Form.Select
//                               className={`${styles.formControl} form-control`}
//                               aria-label="Default select example"
//                             >
//                               <option>Pediatrician</option>
//                               <option value="veteren">Veteren</option>
//                               <option value="apprentice">Apprentice</option>
//                             </Form.Select>
//                           </Col> */}
//                           <Col lg="3" md="4" sm="6" className="my-2">
//                             <label
//                               htmlFor=""
//                               className="form-label themeBlue fw-bold mb-0 d-flex"
//                             >
//                               Registration Number
//                             </label>
//                             <AppInputField
//                               name="registration_number"
//                               placeholder="Enter register number"
//                               className={`${styles.formControl} form-control`}
//                             />
//                           </Col>
//                           <Col lg="3" md="4" sm="6" className="my-2">
//                             <label
//                               htmlFor=""
//                               className="form-label themeBlue fw-bold mb-0 d-flex"
//                             >
//                               Insurance Policy number
//                             </label>
//                             <AppInputField
//                               name="insurance_policy_number"
//                               placeholder="Enter Insurance Policy number"
//                               className={`${styles.formControl} form-control`}
//                             />
//                           </Col>
//                           {/* <Col lg="3" md="4" sm="6" className="my-2">
//                             <label
//                               htmlFor=""
//                               className="form-label themeBlue fw-bold mb-0"
//                             >
//                               Password
//                             </label>
//                             <AppPasswordInputField
//                               name="password"
//                               className={`${styles.formControl} form-control`}
//                             />
//                           </Col>
//                           <Col lg="3" md="4" sm="6" className="my-2">
//                             <label
//                               htmlFor=""
//                               className="form-label themeBlue fw-bold mb-0"
//                             >
//                               Confirm Password
//                             </label>
//                             <AppPasswordInputField
//                               name="confirmPassword"
//                               className={`${styles.formControl} form-control`}
//                             />
//                           </Col> */}
//                           <Col lg="3" md="4" sm="6" className="my-2">
//                             <label
//                               htmlFor=""
//                               className="form-label themeBlue fw-bold mb-0 d-flex"
//                             >
//                               Assigned Client Categories
//                               <RequiredFieldAstrick />
//                             </label>
//                             <CommonMultiSelect
//                               removeConfirmationType={"deleteTherapistAssignedClientType"}
//                               placeholder="Select Category"
//                               name="assigned_client_category"
//                               option={CLIENT_TYPE_OPTIONS}
//                               className={`${styles.formControl} form-control`}
//                             />
//                           </Col>
//                           <Col lg="3" md="4" sm="6" className="my-2">
//                             <label
//                               htmlFor=""
//                               className="form-label themeBlue fw-bold mb-0 d-flex"
//                             >
//                               Timezone
//                               <RequiredFieldAstrick />
//                             </label>
//                             <CommonSelect
//                               placeholder="Select Timezone"
//                               name="timezone"
//                               option={TIMEZONE_OPTIONS}
//                             />
//                           </Col>
//                           <Col sm="6" className="my-2">
//                             <label
//                               htmlFor=""
//                               className="form-label themeBlue fw-bold mb-0 d-flex"
//                             >
//                               Calendly link
//                             </label>
//                             <AppInputField
//                               name="calendly_link"
//                               placeholder="Enter Calendly link here "
//                               className={`${styles.formControl} form-control`}
//                             />
//                           </Col>
//                           <Col sm="6" className="my-2">
//                             <label
//                               htmlFor=""
//                               className="form-label themeBlue fw-bold mb-0 d-flex"
//                             >
//                               About{" "}
//                               <p className="text-muted fw-normal inline-block ms-1 m-0">
//                                 (Description)
//                               </p>
//                             </label>
//                             <AppInputField
//                               name="self_description"
//                               placeholder="Add Bio"
//                               fieldType="textarea"
//                               rows="4"
//                               className={`${styles.formControl} form-control`}
//                             />
//                           </Col>
//                           <Col lg="12" className="my-2">
//                             <Row>
//                               <Col md="6" sm="6" className="my-2">
//                                 <label
//                                   htmlFor=""
//                                   className="form-label themeBlue fw-bold mb-0 d-flex"
//                                 >
//                                   Upload Documents
//                                 </label>
//                                 <AppFileUploadField
//                                   name="documents"
//                                   acl={"private"}
//                                   accept="image/*, application/pdf, .doc, .docx"
//                                   allowedTypes={[MIME_TYPES.pdf, MIME_TYPES.png, MIME_TYPES.jpeg, MIME_TYPES.jpg, MIME_TYPES.webp, MIME_TYPES.doc, MIME_TYPES.docx]}
//                                   className={`${styles.formControl} form-control`}
//                                   onChange={(name, value) => {
//                                     handleAttachDocument(name, value, values?.documents, setFieldValue);
//                                   }}
//                                 />
//                                 {
//                                   values?.documents?.length > 0 &&
//                                   <ViewAttachments
//                                     attachments={values?.documents}
//                                     handleViewPdf={handleViewPdf}
//                                   // title={"Documents :"}
//                                   />
//                                 }
//                               </Col>
//                               <Col md="6" sm="6" className="my-2">
//                                 <Row>
//                                   <Col md="12" sm="12" className="mb-2">
//                                     <label
//                                       htmlFor=""
//                                       className="form-label themeBlue fw-bold mb-0 d-flex"
//                                     >
//                                       Email Signature
//                                     </label>
//                                     <AppInputField
//                                       fieldType="textarea"
//                                       name="email_signature"
//                                       rows={4}
//                                       cols={4}
//                                       placeholder="John Doe&#10;john@example.com&#10;+1 222 222 2222&#10;Street 10, NY, USA "
//                                       className={`${styles.formControl} form-control`}
//                                       maxLength={500}
//                                       style={{ height: "100px" }}
//                                     />
//                                   </Col>
//                                   <Col md="12" sm="12" className="my-2">
//                                     <label
//                                       htmlFor=""
//                                       className="form-label themeBlue fw-bold mb-0 d-flex"
//                                     >
//                                       Upload Signature
//                                     </label>
//                                     <AppFileUploadField
//                                       name="signature_img"
//                                       acl={"public-read"}
//                                       accept="image/png"
//                                       allowedTypes={[MIME_TYPES.png]}
//                                       className={`${styles.formControl} form-control`}
//                                       preview
//                                     />
//                                   </Col>
//                                 </Row>
//                               </Col>
//                             </Row>
//                           </Col>
//                         </Row>
//                       </div>
//                       {console.log("all", values)}
//                       {(!isEmpty(errors) && submitCount > 0) && (
//                         <Row className="mt-4">
//                           <Col lg="12">
//                             <span className="error">{genericFormErrorMsg}</span>
//                           </Col>
//                         </Row>
//                       )}
//                       <Row className="mt-4">
//                         <Col className="my-2" lg="12">
//                           <div
//                             className={`${styles.btnWrpper} btnWrpper d-flex align-items-center gap-10 pt-3`}
//                             style={{ borderTop: "1px solid #41a2a84d" }}
//                           >
//                             <LoadingButton
//                               type="submit"
//                               className="d-flex align-items-center justify-content-center commonBtn"
//                               isLoading={isSubmitting}
//                               onClick={() => {
//                                 validateForm().then((validationErrors) => {

//                                   const fieldOrder = ['profile_picture', 'lastname', 'firstname', 'email', 'phone', 'discipline_id', 'designation_id', 'type', 'registration_number', 'insurance_policy_number', 'assigned_client_category', 'calendly_link', 'self_description', 'documents', 'signature_img', 'email_signature'];
//                                   const errorKey = Object.keys(validationErrors || {}).sort((a, b) => fieldOrder.indexOf(a) - fieldOrder.indexOf(b))?.[0];
//                                   if (errorKey) {
//                                     const errorElement = document.querySelector(`[name="${errorKey}"]`);
//                                     if (errorElement && errorElement.type != "hidden") {
//                                       errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
//                                       errorElement.focus();
//                                     }
//                                     else {
//                                       const parentElement = errorElement?.parentElement;
//                                       if (parentElement) {
//                                         parentElement.scrollIntoView({ behavior: 'smooth', block: 'center' });

//                                         const firstInputInParent = parentElement.querySelector('input, textarea, select');

//                                         if (firstInputInParent) {
//                                           firstInputInParent.focus();
//                                         } else {
//                                           parentElement.focus();  // Fallback to parent itself
//                                         }
//                                       }
//                                     }
//                                   };
//                                 });

//                               }}
//                             >
//                               Save
//                             </LoadingButton>
//                             <Button
//                               className="d-flex align-items-center justify-content-center commonBtn borderedBtn bg-transparent"
//                               onClick={handleClickCancel}
//                             >
//                               Cancel
//                             </Button>
//                           </div>
//                         </Col>
//                       </Row>
//                     </Form>
//                   )}
//                 </Formik>
//               )}
//             </Col>
//           </Row>
//         </Container>
//       </section>
//     </>
//   );
// };

// const defaultInitialValues = {
//   firstname: "",
//   lastname: "",
//   phone: "",
//   email: "",
//   discipline_id: null,
//   type: "veteran",
//   designation_id: null,
//   registration_number: "",
//   insurance_policy_number: "",
//   assigned_client_category: [],
//   calendly_link: "",
//   self_description: "",
//   profile_picture: "",
//   email_signature: "",
//   signature_img: "",
//   status: "active",
//   document_upload: "allow",
//   documents: []
// };

// export default AddTherapist;



